import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';
import { HorizontalRule } from '../HorizontalRule';
import { Icon } from '../Icon';
import { StyledIconProperties } from '../PartialCollapsible/PartialCollapsible.types';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        max-width: ${theme.tggSpacing(rem(85), 212.5)};
        padding: ${theme.tggSpacing([rem(2), rem(2.5)], [5, 6.25])};
        margin: ${theme.tggSpacing([rem(2), 0], [5, 0])};
        border: ${theme.tggSpacing(rem(0.3), 0.75)} solid
            ${theme.palette.grey[50]};
        border-radius: ${theme.tggSpacing(rem(1.5), 3.75)};
        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([rem(3), rem(4)], [7.5, 10])};
            margin: ${theme.tggSpacing([rem(3), 0, rem(2)], [7.5, 0, 5])};
        }
    `}
`;

export const StyledHeadingContainer = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const StyledHeading = styled(Heading)``;

export const StyledButton = styled('button')`
    ${({ theme }: { theme: Theme }) => `
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: ${theme.tggSpacing(rem(2.4), 6)};
        height: ${theme.tggSpacing(rem(2.4), 6)};
        margin: ${theme.tggSpacing(0, 0)};
        cursor: pointer;
        background: none;
        border: ${theme.tggSpacing(rem(0.1), 0.25)} solid
            ${theme.palette.primary.main};
        border-radius: 50%;

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(3.5), 8.75)};
            height: ${theme.tggSpacing(rem(3.5), 8.75)};
        }
    `}
`;

export const StyledChevronIcon = styled(Icon, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledIconProperties>`
    cursor: pointer;
    transition: all 0.3s;
    transform: ${({ $rotated }) =>
        $rotated ? 'rotate(-90deg);' : 'rotate(90deg)'};
`;

export const StyledTimeParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(0.5), 0, rem(2)], [1.25, 0, 5])};
    `}
`;

export const StyledDot = styled('span')`
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`;

export const StyledTrainerParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([0, 0, rem(0.5)], [0, 0, 1.25])};
    `}
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
    `}
`;

export const StyledAvailabilityParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing(0, 0)};
    `}
`;

export const StyledDescriptionParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(2), 0], [5, 0])};
    `}
`;

export const StyledSecondAvailabilityParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing(0, 0)};
    `}
`;
